import React, { useState, useEffect } from 'react';
import './QuestOverview.scss'; // 假设有对应的样式文件

const QuestOverview = ({ current: quest }) => {
    const [activeTab, setActiveTab] = useState('creators');
    const [rankingsData, setRankingsData] = useState({
        date: '',
        timeRange: {},
        topUsers: [],
        topVideos: []
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showAllCreators, setShowAllCreators] = useState(false);
    const displayCount = 10;

    useEffect(() => {
        const fetchRankings = async () => {
            if (!quest?.id) return;

            try {
                setLoading(true);
                const response = await fetch(`/api/v1/quest/top-rankings/${quest.id}`);
                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }
                const result = await response.json();
                if (result.code === 'TOP_RANKINGS_FOUND') {
                    setRankingsData(result.data);
                } else {
                    throw new Error(result.message || 'Failed to fetch data');
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchRankings();
    }, [quest?.id]);

    if (loading) {
        return <div className="loading">Loading...</div>;
    }

    if (error) {
        return <div className="error">Error: {error}</div>;
    }

    if (!quest) {
        return <div className="error">Quest not found</div>;
    }

    return (
        <div className="quest-overview-container">
            {/* 平台标识和说明卡片 */}
            <button className="youtube-btn" data-platform="youtube">
                <svg className="platform-icon" viewBox="0 0 24 24">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"></path>
                </svg>
                <div className="youtube-text">
                    Youtube
                </div>
            </button>
            <div className="platform-desc-card">
                <div className="platform-desc-title">Ranking based on composite score.</div>
                <div className="platform-desc-detail">The ranking drop is comprehensively evaluated based on the playback volume, interaction effect, and completion rate of secondary creation videos.</div>
                <div className="platform-desc-update">Rankings update daily</div>
            </div>
            <div className="tabs">
                <button
                    className={`tab${activeTab === 'creators' ? ' active' : ''}`}
                    onClick={() => setActiveTab('creators')}
                >
                    Creator Rankings
                </button>
                <button
                    className={`tab${activeTab === 'videos' ? ' active' : ''}`}
                    onClick={() => setActiveTab('videos')}
                >
                    Featured Videos
                </button>
            </div>
            <div className="card-section">

                {/* 创作者排名内容 */}
                {activeTab === 'creators' && (
                    <div className="creators-content">
                        <div className="creator-list">
                            {rankingsData.topUsers && rankingsData.topUsers.length > 0 ? (
                                <>
                                    {(showAllCreators ? rankingsData.topUsers : rankingsData.topUsers.slice(0, displayCount)).map((user, idx) => (
                                        <div key={user.username} className="ranking-item">
                                            <div className="rank">#{user.rank}</div>
                                            <img
                                                src={user.avatar}
                                                alt={user.title}
                                                className="avatar"
                                            />
                                            <div className="user-info">
                                                <div className="name">{user.youtubeUsername}</div>
                                                <div className="fans">{user.subscriberCount} Fans</div>
                                            </div>
                                        </div>
                                    ))}
                                    {rankingsData.topUsers.length > displayCount && (
                                        <div
                                            className="show-more-item"
                                            onClick={() => setShowAllCreators(v => !v)}
                                        >
                                            {showAllCreators ? 'Hide' : 'More'}
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div className="no-data">No data available</div>
                            )}
                        </div>
                    </div>
                )}

                {activeTab === 'videos' && (
                    <div className="video-list">
                        {rankingsData.topVideos && rankingsData.topVideos.length > 0 ?
                            rankingsData.topVideos.map((video) => (
                                <div key={video.videoId} className="video-card">
                                    <a
                                        href={video.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                    >
                                        <img
                                            src={`https://img.youtube.com/vi/${video.videoId}/mqdefault.jpg`}
                                            alt={video.title}
                                            className="video-thumbnail"
                                        />
                                    </a>
                                    <div className="video-stats">
                                        <h3 className="video-title">{video.title}</h3>
                                        <div className="video-creator">{video.creator}</div>
                                        <div className='video-date'>
                                            <div>{video.views} views</div>
                                            <div>{video.likes} likes</div>
                                            <div>{video.publishedAt}</div>
                                        </div>
                                    </div>
                                </div>
                            )) : <div className="no-data">No data available</div>
                        }
                    </div>
                )}
            </div>
        </div>
    );
};

export default QuestOverview;